module.exports = __webpack_public_path__ + "img/sterilization.3da25514.png";